import { render, staticRenderFns } from "./TypeControlDetail.vue?vue&type=template&id=12c3cab0&scoped=true"
import script from "./TypeControlDetail.vue?vue&type=script&lang=js"
export * from "./TypeControlDetail.vue?vue&type=script&lang=js"
import style0 from "./TypeControlDetail.vue?vue&type=style&index=0&id=12c3cab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c3cab0",
  null
  
)

export default component.exports